export const calculoTipos = {
	prelacion: "PRELACION",
	manual: "MANUAL"
};

export const aplicacionEstadoTipos = {
	inicial: "NO-APLICADO",
	prelacion: "PRELACION-APLICADO",
	manual: "MANUAL-APLICADO"
};

export const condonarTipos = {
    No: 0,
	Previo: 1,
    Recargos: 2,
    Restante: 3,
    Cantidad: 4
};

export const condonarModes = {
	No: 0,
	Condonar: 1,
	SoloCondonar: 2
};